import React from 'react';
import { Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import styles from './BackButton.module.scss';

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.backButton}>
      <Button color="link" onClick={() => navigate(-1)}>
        <i className="fa fas fa-caret-left"></i>
        <span>BACK</span>
      </Button>
    </div>
  );
};

export default BackButton;
